import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  wrapper: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "middle",
    marginLeft: "6px",
  },

  iconButton: {
    background: "none",
    border: "none",
    padding: "2px",
    margin: 0,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    "&:focus-visible": {
      outline: "2px solid #333333",
      outlineOffset: "2px",
    },
    "&:focus:not(:focus-visible)": {
      outline: "none",
    },
  },

  icon: {
    fontSize: "16px !important",
    width: "16px !important",
    height: "16px !important",
    color: "#595959",
  },

  tooltip: {
    position: "absolute",
    bottom: "calc(100% + 6px)",
    left: "50%",
    transform: "translateX(-50%)",

    backgroundColor: "#333333",
    color: "#FFFFFF",

    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "1.5",
    padding: "8px 12px",
    borderRadius: "4px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.25)",

    width: "max-content",
    maxWidth: "min(260px, 90vw)",

    zIndex: 1,
    pointerEvents: "auto",

    "&::after": {
      content: '""',
      position: "absolute",
      top: "100%",
      left: "50%",
      transform: "translateX(-50%)",
      borderWidth: "5px",
      borderStyle: "solid",
      borderColor: "#333333 transparent transparent transparent",
    },
  },
}));
